import { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { history } from '../../helpers/history';
import { gameActions } from '../../action/GameAction';
import { connect } from 'react-redux';
class DownloadApp extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        this.props.GetUserratings(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
    }

    static getDerivedStateFromProps(props, state) {
        return {
            Userratings: props.Userratings
        }
    }

    componentDidUpdate(prevState, prevProps) {
        if (this.state.Userratings && this.state.Userratings !== prevState.Userratings && this.state.Userratings.length > 0) {
            setTimeout(() => {
                if (window.SetUserratingSlider) {
                    window.SetUserratingSlider()
                }
            }, 500);
        }
    }

    changeTab = (tabid) => {
        localStorage.setItem('tabId', tabid);
        history.push('/generalinfo');
    }

    ConterArray = (Count) => {
        let arrayEmpty = [];
        for (var i = 1; i <= Count; i++) {
            arrayEmpty.push([])
        }
        return arrayEmpty
    }
    render() {
        const { t } = this.props;
        const { i18n } = this.props;
        return (
            <>
                <div class="appDownload">
                    <div class="appDownLft">
                        <h3>{t('lblLaunchApp')}</h3>
                        {/* <h3>{t('lblplay')}. {t('lblWin')}. {t('lblrepeat')}.</h3>
                        <p>{t('lbldownloadquotes1')}<br />{t('lbldownloadquotes2')}</p> */}
                        <div class="apps">
                            <div class="appsCont">
                                <img src="./assets/img/qr.png" />
                                <a ><img src="./assets/img/iOS.png" /></a>
                            </div>
                            <div class="appsCont">
                                <img src="./assets/img/qr.png" />
                                <a ><img src="./assets/img/android.png" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="appDownRht">
                        <img src="./assets/img/mobile.png" />
                    </div>
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    const { latestResult, Userratings } = state.gameReducer;
    const { user, appvariables } = state.loginReducer;
    return { user, latestResult, appvariables, Userratings };
}
const mapActionToProps = {
    GetUserratings: gameActions.GetUserratings
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(DownloadApp))


